// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2s_Cu","selects":"Documents_selects__22ZIg"};